import { GetApp } from "../App"
import { Icon, Icons } from "../Components/Icon"

interface ToggleSwitchProps {
  enabled: boolean;
  name?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  toggleAction: any;
}

export function ToggleSwitch({ enabled, name, toggleAction }: ToggleSwitchProps) {
  const app = GetApp()!;
  const t = app.getT("Component_ToggleSwitch");
  return (
    <div className="ToggleSwitch" onClick={toggleAction}>
      {!enabled && <Icon icon={Icons.CircleLarge} />}
      {t(enabled ? "on" : "off")}
      {enabled && <Icon icon={Icons.CircleFilledLarge} />}
      {name && <input name={name} type="hidden" value={enabled ? "1" : ""} />}
    </div>
  );
}
